import { useEffect, useState } from 'react'
import { useAtom } from 'jotai'
import { Text, Separator, VStack, HStack } from '@chakra-ui/react'
import { monthlyCoursesAtom, monthlyCourseIdAtom } from '@!/atoms/paymentAtom'

export const MonthlyPaymentHeader = () => {
  const [courseName, setCourseName] = useState(null)
  const [price, setPrice] = useState(null)

  const [monthlyCourses] = useAtom(monthlyCoursesAtom)
  const [monthlyCourseId] = useAtom(monthlyCourseIdAtom)

  useEffect(() => {
    const selectedCourse = monthlyCourses.find((course) => course.id === monthlyCourseId)

    if (selectedCourse) {
      setCourseName(selectedCourse.name)
      setPrice(selectedCourse.amount)
    }
  }, [monthlyCourses, monthlyCourseId])

  return (
    <VStack w="100%" gap={4} pt={4} alignItems="stretch">
      <HStack w="100%" justify="space-between">
        <Text fontWeight="bold">月額コース</Text>
        <Text>{courseName}</Text>
      </HStack>
      <Separator />
      <HStack w="100%" justify="space-between">
        <Text fontWeight="bold">お支払い金額</Text>
        <Text>￥{price?.toLocaleString()}(税込)</Text>
      </HStack>
      <Separator />
    </VStack>
  )
}
